const actionPrefix = "timelineViewSettings";
const CHANGE_SHOW_IDENTIFIER = `${actionPrefix}:CHANGE_SHOW_IDENTIFIER`;
const CHANGE_SHOW_DATES = `${actionPrefix}CHANGE_SHOW_DATES`;
const CHANGE_SHOW_DURATION = `${actionPrefix}CHANGE_SHOW_DURATION`;
const CHANGE_SHOW_NARRATIVE = `${actionPrefix}CHANGE_SHOW_NARRATIVE`;
const TOGGLE_SHOW_RELATIONSHIP_TYPES = `${actionPrefix}TOGGLE_SHOW_RELATIONSHIP_TYPES`;
const CHANGE_SHOW_BLOCKS = `${actionPrefix}CHANGE_SHOW_BLOCKS`;
const CHANGE_SHOW_BLOCKED_BY = `${actionPrefix}CHANGE_SHOW_BLOCKED_BY`;
const CHANGE_SHOW_IMAGE = `${actionPrefix}CHANGE_SHOW_IMAGE`;
const CHANGE_SHOW_SUMMARY = `${actionPrefix}CHANGE_SHOW_SUMMARY`;
const CHANGE_SHOW_INFO_ICONS = `${actionPrefix}CHANGE_SHOW_INFO_ICONS`;
const CHANGE_SHOW_TYPE = `${actionPrefix}CHANGE_SHOW_TYPE`;
const CHANGE_SHOW_DEPENDENCIES = `${actionPrefix}CHANGE_SHOW_DEPENDENCIES`;
const CHANGE_SHOW_TODAY_LINE = `${actionPrefix}CHANGE_SHOW_TODAY_LINE`;
const CHANGE_SHOW_ITEM_CARD = `${actionPrefix}CHANGE_SHOW_ITEM_CARD`;

const CHANGE_ZOOM_FROM = `${actionPrefix}CHANGE_ZOOM_FROM`;
const CHANGE_ZOOM_TO = `${actionPrefix}CHANGE_ZOOM_TO`;

const CHANGE_LAYOUT = `${actionPrefix}CHANGE_LAYOUT`;

export const actionTypes = {
  CHANGE_SHOW_IDENTIFIER,
  CHANGE_SHOW_DATES,
  CHANGE_SHOW_DURATION,
  CHANGE_SHOW_NARRATIVE,
  CHANGE_SHOW_BLOCKS,
  CHANGE_SHOW_BLOCKED_BY,
  TOGGLE_SHOW_RELATIONSHIP_TYPES,
  CHANGE_SHOW_IMAGE,
  CHANGE_SHOW_SUMMARY,
  CHANGE_SHOW_INFO_ICONS,
  CHANGE_SHOW_TYPE,
  CHANGE_SHOW_DEPENDENCIES,
  CHANGE_SHOW_TODAY_LINE,
  CHANGE_SHOW_ITEM_CARD,
  CHANGE_ZOOM_FROM,
  CHANGE_ZOOM_TO,
  CHANGE_LAYOUT
};

const changeShowIdentifier = show => {
  return {
    type: CHANGE_SHOW_IDENTIFIER,
    show
  };
};

const changeShowDates = show => {
  return {
    type: CHANGE_SHOW_DATES,
    show
  };
};

const changeShowDuration = show => {
  return {
    type: CHANGE_SHOW_DURATION,
    show
  };
};

const changeShowNarrative = show => {
  return {
    type: CHANGE_SHOW_NARRATIVE,
    show
  };
};

const toggleShowRelationshipTypes = typeIds => {
  return {
    type: TOGGLE_SHOW_RELATIONSHIP_TYPES,
    typeIds
  };
};

const changeShowBlocks = show => {
  return {
    type: CHANGE_SHOW_BLOCKS,
    show
  };
};

const changeShowBlockedBy = show => {
  return {
    type: CHANGE_SHOW_BLOCKED_BY,
    show
  };
};

const changeShowImage = show => {
  return {
    type: CHANGE_SHOW_IMAGE,
    show
  };
};

const changeShowSummary = show => {
  return {
    type: CHANGE_SHOW_SUMMARY,
    show
  };
};

const changeShowInfoIcons = show => {
  return {
    type: CHANGE_SHOW_INFO_ICONS,
    show
  };
};

const changeShowDependencies = show => {
  return {
    type: CHANGE_SHOW_DEPENDENCIES,
    show
  };
};

const changeShowTodayLine = show => {
  return {
    type: CHANGE_SHOW_TODAY_LINE,
    show
  };
};

const changeShowItemCard = show => {
  return {
    type: CHANGE_SHOW_ITEM_CARD,
    show
  };
};

// We are displaying this as "Marker only" in the UI
// so it is just easier to have an action written in this
// form that flips it to our redux store option of "Show Item Card"
const changeShowMarkerOnly = show => {
  return {
    type: CHANGE_SHOW_ITEM_CARD,
    show: !show
  };
};

const changeShowType = (typeId, show) => {
  return {
    type: CHANGE_SHOW_TYPE,
    typeId,
    show
  };
};

const changeZoomFrom = zoomFrom => {
  return {
    type: CHANGE_ZOOM_FROM,
    zoomFrom
  };
};

const changeZoomTo = zoomTo => {
  return {
    type: CHANGE_ZOOM_TO,
    zoomTo
  };
};

const changeLayout = layout => {
  return {
    type: CHANGE_LAYOUT,
    layout
  };
};

export default {
  changeShowIdentifier,
  changeShowDates,
  changeShowDuration,
  changeShowNarrative,
  toggleShowRelationshipTypes,
  changeShowBlocks,
  changeShowBlockedBy,
  changeShowImage,
  changeShowSummary,
  changeShowInfoIcons,
  changeShowDependencies,
  changeShowTodayLine,
  changeShowItemCard,
  changeShowMarkerOnly,
  changeShowType,
  changeZoomFrom,
  changeZoomTo,
  changeLayout
};
